import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { BannerTypesDataService, BannerTypesColumnsService } from '../../../services';
import { BannerType, BannerTypesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-banner-type-details',
  templateUrl: './banner-type-details.component.html',
  styleUrls: ['./banner-type-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class BannerTypeDetailsComponent implements OnInit, OnDestroy {

  public bannerType: BannerType = {};
  public bannerTypes: BannerType[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private bannerTypesDataService: BannerTypesDataService,
    private bannerTypesColumnsService: BannerTypesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Banner Type - Details');
        this.getBannerType(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.bannerType !== 'undefined') {
      this.bannerType = this.dynamicDialogConfig.data.bannerType;
    }
    this.columns = this.bannerTypesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getBannerType(id: number): void {
    this.isLoading = true;
    this.bannerTypesDataService.getBannerType(id).subscribe((response: BannerType|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.bannerType = response;
      }
    });
  }

  list() {
    this.router.navigate(['/banner-types']);
  }

  add() {
    this.router.navigate(['/banner-types/add']);
  }

  edit() {
    this.router.navigate(['/banner-types/edit/' + this.bannerType.id]);
  }

}
@Component({
  selector: 'app-banner-type-details',
  templateUrl: './banner-type-details.component.html',
  styleUrls: ['./banner-type-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogBannerTypeDetailsComponent extends BannerTypeDetailsComponent {
}

